export const dataTrim = (data: any) => {
  const trimmed = {};
  for (const key in data) {
    //@ts-ignore
    typeof data[key] === 'string' ? (trimmed[key] = data[key].trim()) : (trimmed[key] = data[key]);
  }

  return trimmed;
};
